import type { FC } from 'react';

import { SkeletonBodyCopy, SkeletonHeadline } from '@xing-com/skeleton';

import * as Styled from './industry-card.styles';

export const IndustryCardSkeleton: FC = () => (
  <Styled.SkeletonCard data-testid="industry-card-skeleton">
    <SkeletonHeadline amountRows={2} size="medium" />
    <SkeletonBodyCopy amountRows={1} />
  </Styled.SkeletonCard>
);
